import { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken]           = useState(() => localStorage.getItem('cpr_token'));
  const [username, setUsername]     = useState(() => localStorage.getItem('cpr_user'));
  const [role, setRole]             = useState(() => localStorage.getItem('cpr_role') || 'admin');
  const [staffName, setStaffName]   = useState(() => localStorage.getItem('cpr_staff_name') || null);
  const [impersonating, setImpersonating] = useState(() => localStorage.getItem('cpr_impersonating') || null);

  function applySession(token, username, role, staff_name) {
    localStorage.setItem('cpr_token', token);
    localStorage.setItem('cpr_user', username);
    localStorage.setItem('cpr_role', role || 'admin');
    if (staff_name) localStorage.setItem('cpr_staff_name', staff_name);
    else localStorage.removeItem('cpr_staff_name');
    setToken(token);
    setUsername(username);
    setRole(role || 'admin');
    setStaffName(staff_name || null);
  }

  function signIn(token, username, role, staff_name) {
    applySession(token, username, role, staff_name);
  }

  function signOut() {
    localStorage.removeItem('cpr_token');
    localStorage.removeItem('cpr_user');
    localStorage.removeItem('cpr_role');
    localStorage.removeItem('cpr_staff_name');
    localStorage.removeItem('cpr_impersonating');
    localStorage.removeItem('cpr_admin_token');
    localStorage.removeItem('cpr_admin_user');
    localStorage.removeItem('cpr_admin_role');
    localStorage.removeItem('cpr_admin_staff_name');
    setToken(null);
    setUsername(null);
    setRole('admin');
    setStaffName(null);
    setImpersonating(null);
  }

  function startImpersonation(targetToken, targetUsername, targetRole, targetStaffName) {
    localStorage.setItem('cpr_admin_token', localStorage.getItem('cpr_token') || '');
    localStorage.setItem('cpr_admin_user', localStorage.getItem('cpr_user') || '');
    localStorage.setItem('cpr_admin_role', localStorage.getItem('cpr_role') || 'admin');
    localStorage.setItem('cpr_admin_staff_name', localStorage.getItem('cpr_staff_name') || '');
    localStorage.setItem('cpr_impersonating', targetUsername);
    setImpersonating(targetUsername);
    applySession(targetToken, targetUsername, targetRole, targetStaffName);
  }

  function stopImpersonation() {
    const adminToken = localStorage.getItem('cpr_admin_token');
    const adminUser  = localStorage.getItem('cpr_admin_user');
    const adminRole  = localStorage.getItem('cpr_admin_role') || 'admin';
    const adminStaff = localStorage.getItem('cpr_admin_staff_name') || null;
    localStorage.removeItem('cpr_impersonating');
    localStorage.removeItem('cpr_admin_token');
    localStorage.removeItem('cpr_admin_user');
    localStorage.removeItem('cpr_admin_role');
    localStorage.removeItem('cpr_admin_staff_name');
    setImpersonating(null);
    if (adminToken) applySession(adminToken, adminUser, adminRole, adminStaff || null);
  }

  const isAdmin       = role === 'admin';
  const isReadOnly    = role === 'readonly';
  const isAttachments = role === 'attachments';
  const isStaff       = role === 'staff' || role === 'readonly';   // every non-admin employee gets My Dashboard
  const isContractor  = role === 'contractor';

  return (
    <AuthContext.Provider value={{
      token, username, role, staff_name: staffName,
      signIn, signOut,
      startImpersonation, stopImpersonation, impersonating,
      isAuthenticated: !!token,
      isAdmin, isReadOnly, isAttachments, isStaff, isContractor,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
